import type { paymentsApiSpec } from "@wingspanhq/wingspan-api-types";

export const getTotalTransfersAmount = (
  transfers: paymentsApiSpec.PayoutTransfer[]
): number => {
  return transfers.reduce((total, transfer) => total + transfer.amount, 0);
};
